import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { Badge, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import AppContext, { PublishAppContext } from "../../../context/Context";
import APICall from "../../../services/apiCall";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import SoftBadge from "../../common/SoftBadge";
import Scrollbars from "react-custom-scrollbars-2";
import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../common/Loader";
import APIPortalTable from "../../common/Table/APIPortalTable";

const ApplicationInformation = () => {
  const { loginUserDetails } = useContext(AppContext);
  const [unselectableApps, setUnselectableApps] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    applicationList,
    setApplicationList,
    selectedApplication,
    setSelectedApplication,
    rowSelection,
    setRowSelection,
    setPartnerTagline,
    setGetApplicationInfomation,setIsEditMode
  } = useContext(PublishAppContext);

  useEffect(() => {
    setLoading(true);
    var apiParam = { devid: loginUserDetails.parent_dev_id };
    APICall.servertrip(
      "GET",
      "partner_all_apps",
      loginUserDetails,
      apiParam
    ).then(
      (res) => {
        let items = res.data.items;
        let newRes = items.map((data, index) => {
          data["id"] = index;
        });

        let count = [];
        res.data.items.forEach((data, index) => {
          if (data.publish_app_status !== "") {
            unselectableApps.concat(index);
            count = count.concat(index);
          }
        });
        setUnselectableApps(count);
        setApplicationList(res?.data?.items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }
    );
  }, []);

  const columns = [
    {
      accessorKey: "app_name", //simple recommended way to define a column
      header: "Application Name",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
    },
    {
      accessorKey: "app_status", //simple recommended way to define a column
      header: "Application Status",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell, column, renderedCellValue, row, table }) => {
        if (renderedCellValue === "verified") {
          return (
            <h5>
              <SoftBadge className="fs--2" pill bg="success">
                Verified
              </SoftBadge>
            </h5>
          );
        } else if (renderedCellValue === "test") {
          return (
            <h5>
              <SoftBadge className="fs--2" pill bg="danger">
                Test
              </SoftBadge>
            </h5>
          );
        } else if (renderedCellValue === "expired") {
          return (
            <h5>
              <SoftBadge className="fs--2" pill bg="danger">
                Expired
              </SoftBadge>
            </h5>
          );
        } else {
          return (
            <h5>
              <SoftBadge className="fs--2" pill bg="danger">
                Not Verified
              </SoftBadge>
            </h5>
          );
        }
      }, //optional custom cell render
    },
    {
      accessorKey: "app_site_url", //simple recommended way to define a column
      header: "Application URL",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
    },
    {
      accessorKey: "publish_app_status", //simple recommended way to define a column
      header: "Application Published",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell, column, renderedCellValue, row, table }) => {
        if (renderedCellValue === "Published") {
          return (
            <SoftBadge pill bg="success" className="me-2 fs--2">
              Published
            </SoftBadge>
          );
        } else if (renderedCellValue === "In Review") {
          return (
            <SoftBadge pill bg="warning" className="me-2 fs--2">
              In Review
            </SoftBadge>
          );
        } else {
          return (
            <SoftBadge pill bg="danger" className="me-2 fs--2">
              Not Published
            </SoftBadge>
          );
        }
      }, //optional custom cell render
    },
  ];

  // const columns = [
  //   {
  //     dataField: "app_name",
  //     text: "Application Name",
  //     classes: "border-0 align-middle",
  //     headerClasses: "border-0",
  //     sort: true,
  //   },
  //   {
  //     dataField: "app_status",
  //     text: "Status",
  //     classes: "border-0 align-middle",
  //     headerClasses: "border-0",
  //     sort: true,
  //     formatter: (rowContent, row) => {
  //       if (rowContent === "verified") {
  //         return (
  //           <p className="fs--1" style={{ color: "#00d27a", fontWeight: "bold", marginBottom: "0px" }}>
  //             Verified
  //           </p>
  //         );
  //       } else {
  //         return (
  //           <p className="fs--1" style={{ color: "red", fontWeight: "bold", marginBottom: "0px" }}>
  //             Not Verified
  //           </p>
  //         );
  //       }
  //     },
  //   },
  //   {
  //     dataField: "app_site_url",
  //     text: "Application URL",
  //     classes: "border-0 align-middle",
  //     headerClasses: "border-0",
  //     sort: true,
  //   },
  //   {
  //     dataField: "redirect_uri",
  //     text: "Redirect URL",
  //     classes: "border-0 align-middle",
  //     headerClasses: "border-0",
  //     sort: true,
  //   },
  //   {
  //     dataField: "publish_app_status",
  //     text: "Application Published",
  //     classes: "border-0 align-middle",
  //     formatter: (row) => {
  //       if (row === "Published") {
  //         return (
  //           <SoftBadge pill bg="success" className="me-2 fs--2">
  //             Published
  //           </SoftBadge>
  //         );
  //       } else if (row === "In Review") {
  //         return (
  //           <SoftBadge pill bg="warning" className="me-2 fs--2">
  //             In Review
  //           </SoftBadge>
  //         );
  //       } else {
  //         return (
  //           <SoftBadge pill bg="danger" className="me-2 fs--2">
  //             Not Published
  //           </SoftBadge>
  //         );
  //       }
  //     },
  //     headerClasses: "border-0",
  //     sort: false,
  //   },
  // ];

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    nonSelectable: unselectableApps,
    selected: [selectedApplication?.id],
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelectedApplication(row);
    },
  };

  useEffect(() => {
    if (Object.keys(rowSelection).length > 0) {
      let selectedApp = applicationList.find(
        (app) => app.app_id === Object.keys(rowSelection)[0]
      );

      setPartnerTagline(selectedApp?.app_name);
      setSelectedApplication(selectedApp);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (
      selectedApplication?.publish_app_service_id &&
      (selectedApplication?.publish_app_status?.toLowerCase() == "in review" ||
        selectedApplication?.publish_app_status?.toLowerCase() == "published")
    ) {
      setIsEditMode(true);
      let params = {
        service_id: selectedApplication?.publish_app_service_id,
      };
      APICall.servertrip(
        "GET",
        "get_publish_app_details",
        loginUserDetails,
        params
      ).then(
        (res) => {
          const response = res.data.items;
          setGetApplicationInfomation(response);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
        }
      );
    }else{
      setIsEditMode(false);
      setGetApplicationInfomation({});
    }
  }, [selectedApplication?.publish_app_service_id]);

  return (
    <Card className="mb-4 p-0">
      <SikkaCardHeader title={"Application Information"} />
      <CardBody className="px-0">
        <APIPortalTable
          data={applicationList}
          columns={columns}
          loading={loading}
          enablePagination
          CSVFileName={"Published Applications List.csv"}
          enableMultiRowSelection={false}
          onRowSelectionChange={setRowSelection}
          getRowId={(originalRow) => originalRow.app_id}
          state={{ rowSelection }}
          enableRowSelection={(row) => {
            const excludes=["test","expired"];
            if (excludes.includes(row.original.app_status)) {
              return false
            } else {
              return true;
            }
          }}
          // enableRowSelection={true}
          muiTableBodyRowProps={({ row }) => ({
            //add onClick to row to select upon clicking anywhere in the row
            onClick: row?.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
          })}
        />
      </CardBody>
    </Card>
  );
};

export default ApplicationInformation;
